import React from "react";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import "../modal.css";
import html2pdf from "html2pdf.js";
import jiviniLogo from "../../../assets/jivinilogo.png";
// import LoadingSpinnerTable from "../utilites/loader";
import PdfCurrentOrdersTableData from "../../tables/pdfCurrentOrdersTableData";
import moment from "moment";

const SuppliedFromCfaPdfView = ({ id, show, orderDetailData, handleClose }) => {
  const data = [
    {
      title: "Order ID",
      content: orderDetailData?.order?.order_id,
    },
    {
      title: "Company Name",
      content: orderDetailData?.vendor?.name,
    },
    {
      title: "Division",
      content: orderDetailData?.vendorDivision?.name,
    },
    {
      title: "Value Of Order",
      content: orderDetailData?.ordered_value
        ? `₹ ${orderDetailData?.ordered_value}`
        : "--",
    },
    {
      title: "Order Status",
      content: orderDetailData?.status,
    },
    {
      title: "Doctor Name",
      content: orderDetailData?.order?.doctor?.name,
    },
    {
      title: "Pharmacy Name",
      content: orderDetailData?.order?.pharmacy_id
        ? orderDetailData?.order?.pharmacy?.pharmacy_name
        : orderDetailData?.order?.doctor?.pharmacy_type == "attach"
        ? orderDetailData?.order?.doctor?.doctorAttachPharmacy?.pharmacy
            ?.pharmacy_name
        : orderDetailData?.order?.doctor?.pharmacy_type == "self"
        ? orderDetailData?.order?.doctor?.doctorSelfPharmacy?.pharmacy_name
        : orderDetailData?.order?.doctor?.pharmacy_type == "dispensing" &&
          "Dispensing",
    },
    {
      title: "Mobile Number",
      content: orderDetailData?.order?.doctor?.mobile,
    },
  ];

  const data2 = [
    {
      title: "Alternate Mobile Number",
      content: orderDetailData?.order?.doctor?.alternate_mobile,
    },
    {
      title: "Email Address",
      content: orderDetailData?.order?.doctor?.email,
    },
    {
      title: "Address",
      content: `${orderDetailData?.order?.doctor?.address?.address_one}, ${orderDetailData?.doctor?.address?.address_two}, ${orderDetailData?.doctor?.address?.address_three}`,
    },
    {
      title: "Landmark",
      content: orderDetailData?.order?.doctor?.address?.landmark,
    },
    {
      title: "Concerned FF Name",
      content: orderDetailData?.order?.orderHeirarchy?.fieldForceUser?.name,
    },
    {
      title: "Concerned FF Mobile Number",
      content: orderDetailData?.order?.orderHeirarchy?.fieldForceUser?.mobile,
    },
    {
      title: "Concerned CFA Name",
      content: orderDetailData?.order?.cfa?.cfa_name,
    },
    {
      title: "Concerned CFA Mobile Number",
      content: orderDetailData?.order?.cfa?.mobile,
    },
  ];
  const exportToPdf = () => {
    const toRender = document.getElementById("toRender");
    const options = {
      margin: [30, 10],
      filename: "orders.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { dpi: 192, letterRendering: true },
      jsPDF: { unit: "pt", format: "a4", orientation: "portrait" },
    };

    html2pdf().set(options).from(toRender).save();
  };

  return (
    <>
      <Modal
        centered
        show={show}
        onHide={handleClose}
        dialogClassName="current-orders-view-container col-10 mx-auto px-3"
        // style={{ height: '50rem' }}
      >
        <ModalHeader>
          <div className=" d-flex justify-content-between w-100 ">
            <div>
              <span className="fn_Nunito fw_700 fs_14 Medium_Purple my- px-0">
                {orderDetailData?.order_id} - View
              </span>
            </div>
            <div className="d-flex justify-content-end  gap-2">
              <div className="mt-1">
                <button
                  type="button"
                  onClick={() => {
                    exportToPdf();
                  }}
                  className="modal-submit-btn text-white px-4 py-2 fs_14"
                >
                  print
                </button>
              </div>
            </div>
          </div>
        </ModalHeader>
        <ModalBody className="w-100 h-100">
          <div
            className="w-100"
            style={{ overflowY: "scroll", height: "40rem" }}
          >
            <div id="toRender" className="mx-2">
              <div className="my-2 mb-4">
                <img src={jiviniLogo} />
              </div>
              <div className="d-flex ">
                <div className="col-6 col-lg-5">
                  {data.map((items, index) => (
                    <div className="d-flex" key={index}>
                      {items?.title != "Order Status" ? (
                        <>
                          <div className="col-6 col-sm-4">
                            <span className="fs_14">
                              {items?.title}
                            </span>
                          </div>
                          <span className="fs_14 ms-3 col-6 mt-1">
                            {items?.content}
                          </span>
                        </>
                      ) : (
                        <>
                          <div className="col-6 col-sm-4">
                            <span className={`fs_14`}>
                              {items?.title}
                            </span>
                          </div>
                          <span
                            className={`fs_14 ms-3 col-6 mt-1 ${
                              orderStatus.find(
                                (e) => e?.status == items?.content
                              )?.color
                            }`}
                          >
                            {
                              orderStatus.find(
                                (e) => e?.status == items?.content
                              )?.value
                            }
                          </span>
                        </>
                      )}
                    </div>
                  ))}
                </div>
                <div className="col-6">
                  {data2.map((items, index) => (
                    <div className="d-flex gap-" key={index}>
                      <div className="col-6 col-sm-5">
                        <span className="fs_14">
                          {items.title}
                        </span>
                      </div>
                      <span className="fs_14 ms-3 col-6">{items.content}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="mt-3">
                <p className="fn_Nunito fw_700 fs_14 Medium_Purple my- px-2 label-text">
                  Order Details - {orderDetailData?.order?.order_id}
                </p>
                <div className="mt-3">
                  <PdfCurrentOrdersTableData
                    orderProducts={orderDetailData?.order?.orderProducts}
                    total={orderDetailData?.order?.total}
                  />
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default SuppliedFromCfaPdfView;

export const orderStatus = [
  { status: "pending", value: "Approval Pending", color: "text-warning" },
  { status: "approved", value: "Approved", color: "color_2ad3e7" },
  { status: "fully_invoiced", value: "Fully Invoiced", color: "text_green" },
  {
    status: "partially_invoiced",
    value: "Partially Invoiced",
    color: "Medium_Purple",
  },
  { status: "rejected", value: "Rejected", color: "text-danger" },
  { status: "approval_failed", value: "Approval Failed", color: "text-danger" },
  { status: "cancelled", value: "Cancelled", color: "text-danger" },
  { status: "expired", value: "Expired", color: "text-danger" },
  { status: "acknowledged", value: "Acknowledged", color: "text-danger" },
  {
    status: "partially_acknowledged",
    value: "Partially acknowledged",
    color: "Medium_Purple",
  },
  { status: "hold", value: "Hold", color: "text-danger" },
];
